enum CartRoutes {
  Cart = '/:country/cart',
  ProducerCart = '/:country/cart/:producerSlug',
}

export default CartRoutes
